import { render, staticRenderFns } from "./ListRoutines.vue?vue&type=template&id=0c8006b4&scoped=true&"
import script from "./ListRoutines.vue?vue&type=script&lang=js&"
export * from "./ListRoutines.vue?vue&type=script&lang=js&"
import style0 from "./ListRoutines.vue?vue&type=style&index=0&id=0c8006b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8006b4",
  null
  
)

export default component.exports